import React, { useState } from 'react'
import styled from 'styled-components'
import { useQueryParams, StringParam, ArrayParam } from 'use-query-params'
import { Text } from '../../components/Text'
import { STYLES } from '../../static/style'
import { FilterIcon } from '../../components/Icon/FilterIcon'
import SchoolSearchFilterModal from './SchoolSearchFilterModal'

interface ISchoolSearchFilter {
  onClick: () => void
}

const StyledSchoolSearchFilter = styled.div<{ $isFilterEnabled: boolean }>`
  position: fixed;
  top: 3.4rem;
  z-index: 8;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${STYLES.COLOR_WHITE};
  padding: 0.25rem 1rem;
  border-radius: 2rem;
  box-shadow: 1px 1px 3px #666;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  opacity: 0.8;
  &:hover {
    color: ${STYLES.PRIMARY_COLOR};
    opacity: 1;
  }
  ${({ $isFilterEnabled }) =>
    $isFilterEnabled &&
    `
    && {
      background-color: ${STYLES.PRIMARY_COLOR};
      color: ${STYLES.COLOR_BLACK};
      font-weight: ${STYLES.FONT_WEIGHT_BOLD};
    }
  `}
`

const StyledFilterIcon = styled(FilterIcon)`
  margin-right: ${STYLES.GUTTER};
`

const SchoolSearchFilter = () => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false)
  const [{ levels, sector, gender }] = useQueryParams({
    levels: ArrayParam,
    sector: StringParam,
    gender: StringParam,
  })
  const isFilterEnabled = !!(levels || sector || gender)
  return (
    <>
      <StyledSchoolSearchFilter
        $isFilterEnabled={isFilterEnabled}
        onClick={() => {
          setIsShowModal(true)
        }}
      >
        <StyledFilterIcon />
        <Text>Filter</Text>
      </StyledSchoolSearchFilter>
      {isShowModal && (
        <SchoolSearchFilterModal onCloseClick={() => setIsShowModal(false)} />
      )}
    </>
  )
}

export default SchoolSearchFilter
